import { FC } from 'react';

import DiagnosticCard from '../DiagnosticCard';
import { PdfDiagnostic } from '../types';

import './index.scss';

interface IDiagnosticCardProps {
  diagnostic: PdfDiagnostic;
}

const DiagnosticCardWrapper: FC<IDiagnosticCardProps> = ({ diagnostic }) => {
  return (
    <div className="pdf-diagnostic-card-wrapper pdf-keep">
      <DiagnosticCard diagnostic={diagnostic} />
    </div>
  );
};

export default DiagnosticCardWrapper;
